export default {
  newApplicationVersion:
    'Na voljo je posodobljena verzija Iryo Moshi. Kliknite osveži in jo začnite uporabljati.',
  appOffline:
    'Povezava s strežnikom je prekinjena. Aplikacija morda ne bo delovala.'
};
